/**
 * Lightbox
 * `[data-lightbox="<画像URL>"]` をクリックすると拡大画像をオーバーレイ表示。
 */
export const initLightbox = () => {
  const triggers = document.querySelectorAll('[data-lightbox]');
  if (!triggers.length) return;

  // オーバーレイ生成（1つを使い回す）
  const box = document.createElement('div');
  box.className = 'lightbox';
  box.innerHTML = `
    <button type="button" class="lightbox__close" aria-label="閉じる">
      <svg viewBox="0 0 24 24" width="28" height="28">
        <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
    <img class="lightbox__img" src="" alt="">
  `;
  document.body.appendChild(box);

  const img = box.querySelector('.lightbox__img');
  const closeBtn = box.querySelector('.lightbox__close');

  const open = (src) => {
    img.src = src;
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    box.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      open(trigger.dataset.lightbox);
    });
  });

  closeBtn.addEventListener('click', close);
  box.addEventListener('click', (e) => {
    // 画像以外（背景）クリックで閉じる
    if (e.target === box) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
};
